export default "__VITE_ASSET__b048d7fb__"